import React from 'react';
import PropTypes from 'prop-types';
import NiceModal from '@ebay/nice-modal-react';

// Import styles
import { StyledQuestionIcon } from './styles';

// Import helpers
import { CONFIGURATOR_MODALS } from 'helpers/variables';

const { CHANNELS } = CONFIGURATOR_MODALS;

const PacketMainModal = ({ href, packetName, space }) => {
	const toggle = () => NiceModal.show(CHANNELS, { packetName, href });

	return (
		<StyledQuestionIcon type="question-circle" onClick={toggle} space={space} />
	);
};

PacketMainModal.propTypes = {
	href: PropTypes.string,
	packetName: PropTypes.string,
	space: PropTypes.number
};

export default React.memo(PacketMainModal);
